import { render, staticRenderFns } from "./TreasuryForm.vue?vue&type=template&id=22731762&"
import script from "./TreasuryForm.vue?vue&type=script&lang=js&"
export * from "./TreasuryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports